import { Helmet } from 'react-helmet-async';
import customers from "../feature/customers.jpg";
import customercapture0 from "../feature/customercapture0.webp";
import behaviorinsights from "../feature/behaviorinsights.webp";
import customersegments from "../feature/customersegments.jpg";
import FeatureSection from './FeatureSection';
import FeaturesBottom from './FeaturesBottom';
import FeatureHeroSection from './FeatureHeroSection';
import main from "../feature/cust-mem.webp";
import ContactIcon from './ContactIcon';

function CustomerMemory(){

    return (
        <>
            <Helmet>
                <title>Kadhr — Customer Memory</title>
                <meta
                    name="description"
                    content="Kadhr automatically builds rich customer profiles from every order — helping you understand what your customers buy, how often they return, and what they care about."
                />
            </Helmet>

            <main className="mtopcon0 ovrflwhdn" id="up">
                <ContactIcon/>
                <div className="row">                    
                    <FeatureHeroSection
                        title="Know your customers without keeping notes"
                        description="Kadhr automatically builds a profile for every customer — tracking what they buy, how often they return, and what they care about."
                        image={main}
                    />
                    <div className="col-12 text-center mt-5 pt-6indx0" id='features'>
                        <FeatureSection title="Purchase History" description="Every order is saved and organized — so you always know what each customer bought." image={customercapture0} reverse />
                        <FeatureSection title="Customer Segments" description="Automatically group customers into new, repeat, and loyal — no manual tagging needed." image={customersegments} />
                        <FeatureSection title="Behavior Insights" description="Understand buying patterns like frequency, spend, and preferences at a glance." image={behaviorinsights} reverse />
                        <FeatureSection title="Always Up to Date" description="Customer profiles update automatically with every new order — no extra work." image={customers} />
                    </div> 
                

                    <FeaturesBottom/>


                </div>
            </main>
        </>
    );
}

export default CustomerMemory;
